import * as React from 'react';
import { useMemo, useState } from 'react';

import DegreeDescriptionPageElementRefsContext from 'bundles/degree-description/contexts/DegreeDescriptionPageElementRefsContext';

export const DegreeDescriptionPageElementRefsProvider: React.LegacyFunctionComponentWithChildren = ({ children }) => {
  /**
   * Store the EOI buttons in Hero section as state in context instead of using useRef hook because:
   * 1. The buttons lays in very low level of the dom tree, if using ref to pass down, it would be passing through a few levels.
   * 2. Change of ref object does not trigger useEffect hook in EoiButtonsMobileFooter which breaks the responsiveness of the footer display
   */
  const [floatingEoiButtonsContainerRef, setFloatingEoiButtonsContainerRef] = useState<HTMLElement | null>(null);
  const [heroBannerRef, setHeroBannerRef] = useState<HTMLElement | null>(null);
  const [navbarRef, setNavbarRef] = useState<HTMLElement | null>(null);

  return (
    <DegreeDescriptionPageElementRefsContext.Provider
      value={useMemo(
        () => ({
          floatingEoiButtonsContainerRef,
          setFloatingEoiButtonsContainerRef,
          heroBannerRef,
          setHeroBannerRef,
          navbarRef,
          setNavbarRef,
        }),
        [floatingEoiButtonsContainerRef, heroBannerRef, navbarRef]
      )}
    >
      {children}
    </DegreeDescriptionPageElementRefsContext.Provider>
  );
};
